import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Image } from 'components';
import { media } from "utils/media";
import mdToHtml from "../utils/mdToHtml";

const SectionNumbered = ({ locale, content }) => {
  let localList = null;
  switch(locale) {
    case 'uk':
      localList = content.listUk
      break;
    case 'en':
      localList = content.listEn
      break;
    case 'se':
      localList = content.listSe
      break;
    default:
      localList = null;
      break;
  }
  return (
  <div className={cx('section-numbered', content.reverse ? 'reverse' : '', [content.className])}>
    <div className='section-text'>
      <h2 dangerouslySetInnerHTML={{ __html: content.title }} />
      <div dangerouslySetInnerHTML={{ __html: mdToHtml(localList) }} />
    </div>
    <div className='section-media'>
      <Image url={media(content.image)} alt={content.title} />
      <Image url={media(content.iconNumber)} alt='Icon Ribbon Step' className='icon-number' />
    </div>
  </div>)
};

SectionNumbered.propTypes = {
  locale: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired
};

SectionNumbered.defaultProps = {
  locale: 'Uk',
  content: {}
};

export default SectionNumbered;
